import React from 'react'
import Header from '../components/Header'
import { Watchlater } from '../components/Watchlater'

export default function WatchLaterpage() {
  return (
    <>
    <Header/>
    <Watchlater/>
    </>
  )
}
